import { config } from 'src/config';

export default config.REACT_APP_ENVIRONMENT === 'development';
